import styled from 'styled-components';

export const CareerContainer = styled.div`
  .moving-txt {
    font-family: Vollkorn, sans-serif;
    font-size: 48px;
    letter-spacing: -0.36px;
    line-height: 59px;
    span {
      display: block;
    }

    @media only screen and (max-width: 767px) {
      display: none;
      font-size: 38px;
      line-height: 47px;

      span {
        &:first-child {
          transform: translateX(60%);
        }

        &:last-child {
          transform: translate(-40%, 30px);
        }
      }
    }
  }

  .inner-hero-content p {
    font-size: 18px;
    letter-spacing: 0.2px;
    margin-bottom: 35px;
    line-height: 28px;
  }
  .career-hero .pink-btn {
    min-width: 190px;
  }
  .career-hero .pink-btn:before {
    background-color: ${({ theme: { colors } }) => colors.white};
  }

  .inner-hero-area {
    position: relative;
    padding: 112px 0 70px;

    @media only screen and (max-width: 767px) {
      padding: 62px 0 80px;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      background-color: #fafafa;
      opacity: 0.025;
      width: 400px;
      height: 650px;

      @media only screen and (max-width: 767px) {
        left: 50px;
        width: 140px;
      }
    }

    h1 {
      line-height: 59px;
      margin-bottom: 50px;
      font-size: 85px;
      letter-spacing: -0.63px;

      @media only screen and (max-width: 767px) {
        h1 {
          line-height: 55px;
          font-size: 48px;
          margin-bottom: 15px;
        }
      }
    }
  }

  .inner-banner-img img {
    width: 100%;
  }
  .career-hero-main .inner-banner-img {
    margin-left: calc(((100vw - 1200px) / 2) + 307px);
    position: relative;
    z-index: 9;
    padding-bottom: 78px;
  }
  .career-images-area {
    padding: 180px 0;
    margin-top: -135px;
    position: relative;
  }
  .career-images-area::before {
    background-color: #d7d7d7;
    position: absolute;
    opacity: 0.21;
    top: 0;
    bottom: 0;
    width: 37%;
    height: 58.5%;
    right: 0;
    content: '';
    z-index: 0;
  }
  .career-first-img {
    margin-top: 160px;
  }
  .career-hashtag-txt {
    color: #ff4552;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.18px;
    line-height: 22px;
    text-align: right;
  }
  .career-images-area .career-hashtag-txt {
    padding-right: 80px;
  }
  .career-extended-img {
    min-height: 461px;
    width: 750px;
    background-size: cover;
    background-position: center;
    margin: 80px 0 100px;
  }
  .career-first-img {
    margin-top: 160px;
    width: 88%;
  }
  .career-images-area .rotated-tab-txt p:after {
    background-color: #0a090b;
  }
  .career-images-area .rotated-tab-txt {
    top: 57%;
  }
  .career-why-us {
    padding: 35px 0;
    min-height: 340px;
  }
  .career-why-us {
    padding: 35px 0;
    min-height: 340px;
    align-items: center;
    display: flex;
  }
  .career-why-us .big-heading {
    margin: 0;
  }
  .single-career-feature p {
    color: #ffffff;
    font-size: 18px;
    letter-spacing: 0.2px;
    line-height: 28px;
  }
  .single-career-feature {
    background-position: center;
    background-size: cover;
    min-height: 400px;
    padding: 60px 60px 10px;
  }
  .single-career-feature h3 {
    color: #ffffff;
    font-family: 'Be Vietnam Pro';
    font-size: 48px;
    font-weight: normal;
    letter-spacing: -0.36px;
    line-height: 57px;
  }
  .section-3-text {
    padding: 80px 60px 25px;
    min-height: 400px;
  }
  .section-3-text h3 {
    font-family: 'Be Vietnam Pro';
    color: #0a090b;
    font-size: 48px;
    font-weight: 500;
    letter-spacing: -0.36px;
    line-height: 57px;
  }
  .we-care-single h3 {
    color: #ffffff;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: -0.24px;
    margin: 0;
  }
  .we-care-single p {
    color: #ffffff;
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
  }
  .we-care-single {
    padding: 25px 0;
  }
  .we-care-block {
    padding: 45px 0;
  }
  .we-care-main {
    padding: 180px 0 100px;
    position: relative;
  }
  /* .we-care-main:before {
    background-color: #fafafa;
    position: absolute;
    opacity: 0.03;
    top: 0;
    bottom: 0;
    width: 40%;
    height: 22%;
    left: 0;
    content: '';
    z-index: 0;
  } */
  .we-care-img {
    position: absolute;
    right: -34%;
    height: 100%;
    width: 50%;
    background-position: center;
    background-size: cover;
  }
  .we-care-area {
    position: relative;
  }
  /* .we-care-main::after {
    color: rgba(255, 255, 255, 0.05);
    font-size: 158px;
    font-weight: bold;
    letter-spacing: 12px;
    content: 'BENEFITS';
    position: absolute;
    top: 90px;
    right: -80px;
    white-space: nowrap;
    z-index: 0;
  } */
  .position-select {
    width: 100%;
    height: 44px;
    border: 1px solid #979797;
    border-radius: 4px;
    background-color: #ffffff;
    padding: 10px;
  }
  .open-position-filter {
    position: relative;
  }
  .search-btn {
    position: absolute;
    right: 11px;
    background-color: transparent;
    border: none;
    color: #979797;
    font-size: 19px;
    top: 11px;
  }
  .search-btn:hover {
    color: #ff4552;
  }
  .open-position-main .big-heading {
    margin: 0;
  }
  .open-position-main {
    padding: 140px 0;
  }
  .accordion-area {
    padding-top: 45px;
  }
  .accordion-head {
    display: flex;
    padding: 26px 34px;
    background-color: #fafafa;
    color: #0a090b;
    font-size: 21px;
    letter-spacing: -0.16px;
    line-height: 30px;
    justify-content: space-between;
  }
  .single-open-position {
    padding: 23px 34px;
    border-bottom: 1px solid rgba(150, 150, 150, 0.5);
  }
  .single-open-position button {
    border: none;
    background: transparent;
    font-family: 'Be Vietnam Pro';
    color: #ff4552;
    font-size: 21px;
    font-weight: 600;
    letter-spacing: -0.16px;
    line-height: 30px;
  }
  .single-open-position button:hover {
    color: #111;
  }
  .single-open-position p {
    color: #0a090b;
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
    margin: 0;
  }
  .accordion-single .accordion-body .single-open-position:last-child {
    border: none;
  }

  .jobs-count {
    font-family: 'Be Vietnam Pro';
    font-size: 20px;
    margin: 20px 0 20px 0;
    color: #5f5f5f;
    margin-top: 60px;
    margin-bottom: 35px;
  }

  .location-placeholder {
    font-family: Vollkorn;
    font-size: 20px;
    -webkit-letter-spacing: -0.15px;
    -moz-letter-spacing: -0.15px;
    -ms-letter-spacing: -0.15px;
    letter-spacing: -0.15px;
    line-height: 28px;
    padding-top: 10px !important;
    padding-left: 19px !important;
  }

  @media (max-width: 1024px) {
    .career-hero-main .inner-banner-img {
      width: 88%;
    }
    .single-career-feature h3 {
      font-size: 28px;
      line-height: 33px;
    }
    .single-career-feature {
      padding: 60px 10px 10px;
    }
    .section-3-text p {
      font-size: 38px;
      line-height: 47px;
    }
  }

  @media (max-width: 990px) {
    .we-care-img {
      display: none;
    }
    .we-care-main::after {
      font-size: 108px;
    }
    .we-care-main {
      overflow: hidden;
    }
  }

  @media (max-width: 767px) {
    .inner-hero-content p {
      font-size: 14px;
      line-height: 24px;
    }
    .career-hero .pink-btn {
      min-width: 190px;
      display: block;
      width: 100%;
    }
    .career-hero-main .inner-banner-img {
      width: 96%;
    }
    .career-first-img {
      margin-top: 60px;
      width: 88%;
    }
    .career-images-area .career-hashtag-txt {
      padding-right: 0;
    }
    .career-extended-img {
      min-height: 371px;
      width: 100%;
      margin: 40px 0 50px;
    }
    .career-images-area {
      padding: 90px 0;
      margin-top: -115px;
    }
    .career-img {
      position: relative;
      left: -15px;
    }
    .career-extended-img {
      position: relative;
      right: -15px;
      left: auto;
    }
    .single-career-feature {
      padding: 20px 10px;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: flex-end;
      min-height: auto;
    }
    .section-3-text {
      padding: 50px 20px;
      min-height: 290px;
    }
    .section-3-text p {
      font-size: 28px;
      line-height: 37px;
    }
    .we-care-area .big-heading {
      text-align: center;
      margin: 0;
    }
    .we-care-main::after {
      display: none;
    }
    .we-care-main {
      padding: 60px 0 20px;
    }
    .we-care-single h3 {
      font-size: 22px;
    }
    .we-care-single {
      padding: 10px 0;
      text-align: center;
    }
    .open-position-main {
      padding: 70px 0;
    }
    .open-position-main .big-heading {
      margin: 0 0 20px;
    }
    .open-position-filter {
      margin-bottom: 15px;
    }
    .accordion-head {
      padding: 15px 21px;
      font-size: 17px;
    }
    .single-open-position {
      padding: 17px 15px;
    }
  }
`;

export const ImageBanner = styled.div`
  margin-left: calc((100vw - 1185px) / 2);
  margin-bottom: 135px;
`;
